module.exports = __webpack_public_path__ + "static/media/addWallet.4c52fcc9.png";